export const Paragraph = ({ children, size = "base", weight = "regular" ,className="" }) => {
  return <p className={`text-${size} font-${weight} ${className}`}>{children}</p>;
};
